module.exports = __webpack_public_path__ + "img/wp_clean.2d94d252.svg";